import { MuiAlertSnackbar, SnackbarState } from '.';
import { SnackbarContext } from './context';
import { useSnackbarAlert } from './use-snackbar-alert';

/**
 * This component is expected to be used at the top level of the app, wrapping the entire app. It currently exists in fox-shell alongside theme provider.
 * It provides a context for managing snackbar state and rendering the snackbar component.
 */
export const SnackbarContextProvider = ({ children, initialState }: { children: React.ReactNode; initialState?: Partial<SnackbarState> }) => {
	const [snackbar, setSnackbar] = useSnackbarAlert(initialState);
	const closeSnackbar = () => {
		setSnackbar({ open: false });
	};
	return (
		<SnackbarContext.Provider value={{ snackbar, setSnackbar, closeSnackbar }}>
			{children}
			<MuiAlertSnackbar {...snackbar} onClose={closeSnackbar} />
		</SnackbarContext.Provider>
	);
};
